import React from 'react';
import { Box } from '@chakra-ui/react';
import RoutineIdentifierRow from '@components/molecules/RoutineIdentifierRow';

const RoutineIdentifier = ({ data = null }) => {
  const { routineIdentifierItems } = data;
  return (
    <>
      {routineIdentifierItems.map((item, i) => (
        <Box key={`routineIdentifierItems${i + 1}`}>
          <RoutineIdentifierRow
            step={item.step}
            title={item.title}
            image={item.image}
            content={item.content.data.content}
            buttonText={item.buttonText}
            buttonLink={item.buttonLink}
            newWindow={item.newWindow}
            bgImage={item.bgImage}
            bgColour={item.bgColour}
          />
        </Box>
      ))}
    </>
  );
};

export default RoutineIdentifier;
